module.exports = __webpack_public_path__ + "img/icon_service1.36cf7d4e.png";